// #87 / SEC-085: window events that let socket.js and sessionRefresh.js
// cooperate without importing each other. sessionRefresh.js → session.js →
// socket.js is already an import chain, so socket.js importing
// sessionRefresh.js back would be a cycle.
//
// - SESSION_REFRESH_REQUESTED_EVENT: the socket was refused ('unauthorized')
//   or its token expired; please run the single-flight refresh.
// - SESSION_REFRESHED_EVENT: a refresh succeeded and localStorage now holds
//   the new pair; a socket that wants to be connected may reconnect.
//
// Names match origin/feat/chat so the pooled-inbox merge lines up.
export const SESSION_REFRESHED_EVENT = "astra:session-refreshed";
export const SESSION_REFRESH_REQUESTED_EVENT = "astra:session-refresh-requested";

// The message sessionRefresh.js's request interceptor rejects with when the
// proactive refresh fails and it has already forced the logout (full reload to
// /login). The request was never sent, so the error has no `response`; callers
// that must react to the forced logout (paymentErrors.isUnauthorized) match it.
export const SESSION_EXPIRED_MESSAGE = "Session expired";
